<style lang="less">
.add-view .el-upload {
  text-align: center !important;
}

.img-upload {
  width: 100% !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;

  .add-view .el-upload {
    text-align: center;
  }

  .update {
    display: flex;
    flex-wrap: wrap;
    width: 100% !important;

    &__operation {
      display: flex;
      flex-direction: column;
      margin: 0 20px 20px 0;
      position: relative;

      &__button {
        width: 100%;
        height: 30px;
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-delete {
          width: 50%;
          height: 100%;
          line-height: 30px;
          text-align: center;
        }

        &__replace {
          width: 50%;
          height: 100%;
          line-height: 30px;
          text-align: center;
          color: #fff;

          .el-icon-edit-outline {
            text-align: center;
          }

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            border: none;
            overflow: hidden;
            background-color: rgba(0, 0, 0, 0);
          }
        }
      }
    }

    .avatar-uploader .el-upload {
      border-radius: 6px;
      cursor: pointer;
      position: relative;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;
        overflow: hidden;
      }
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      align-items: center;
      justify-content: center;
      text-align: center;
      border: 1px dashed #d9d9d9;
    }

    .avatar {
      width: 100%;
      min-width: 100px;
      min-height: 100px;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .upload-tips {
    color: #999;
    font-size: 8px;
    line-height: 15px;
    margin-top: 5px;
  }

  .text-info {
    position: absolute;
    left: -6px;
    top: 0;
    width: 60px;
    height: 22px;
    color: #fff;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    background: #409eff;
    z-index: 9;

    .text-info-horn {
      position: absolute;
      left: 0;
      bottom: -6px;
      width: 6px;
      height: 6px;
    }
  }
}
</style>
<template>
  <div class="img-upload">
    <div class="text-info" v-if="textInfo">
      {{ textInfo }}
      <img class="text-info-horn" src="https://casio-store-1257315589.cos.ap-shanghai.myqcloud.com/casio-store-shop/static/shop-center/horn.png" />
    </div>
    <div class="update">
      <slot></slot>
      <div class="update__operation" v-for="(img, index) in list" v-loading="img.loading" v-dragging="{ item: img, list: list, group: randomDraggingGroup }" :key="index"
        :style="{ width: size.width, height: size.height }">
        <video v-if="accept == 'video/mp4'" class="avatar" :src="img.url"></video>
        <img v-else class="avatar" :preview="previewNumber" :src="img.url" />
        <div class="update__operation__button" v-if="showIcon && !disabled">
          <el-upload class="update__operation__button__replace" :action="action" :accept="accept" :on-success="res => updateUpdateSuccess(res, index, img)" :show-file-list="false" :auto-upload="true"
            :headers="uploadHeaders" :before-upload="
              file => {
                beforeUpdateUpload(file, img);
              }
            " :on-error="
              err => {
                uploadUpdateError(err, img);
              }
            " drag>
            <i class="el-icon-edit-outline">更换</i>
          </el-upload>
          <i class="el-icon-delete " @click="deleteImg(index)"> 删除 </i>
        </div>
      </div>
      <div v-if="list.length < limit">
        <el-upload v-loading="loading" class="avatar-uploader" ref="my-upload" :limit="limit" :show-file-list="showfilelist" :auto-upload="autoupload" :multiple="multiple" :action="action"
          :file-list="filelist" :headers="uploadHeaders" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :accept="accept" drag :on-exceed="uploadExceed">
          <i class="el-icon-plus avatar-uploader-icon" :style="{
            width: size.width,
            height: size.height,
            lineHeight: size.height
          }">
          </i>
        </el-upload>
        <a-button v-if="showLibraryBtn" @click="visible = true" :style="{width:size.width}">素材库</a-button>
      </div>
      <slot name="tips"></slot>
    </div>

    <div class="upload-tips" v-if="showTips">{{ getTextPrompt }}</div>

  </div>
</template>
<script>
import store from '@/store'
import config from '@/config'

export default {
  components: {
  },
  props: {
    showLibraryBtn: {
      type: Boolean,
      default: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showTips: {
      type: Boolean,
      default: true
    },
    previewNumber: {
      type: String,
      default: () => {
        return 'casio-stre-shop' + Math.ceil(Math.random() * 10000)
      }
    },
    textPrompt: {
      type: String,
      default: () => {
        return ''
      }
    },
    hideTextPrompt: Boolean,
    textInfo: {
      type: String,
      default: () => {
        return ''
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    action: {
      type: String,
      default: () => {
        return config.api.uploadURL
      }
    },
    showList: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    size: {
      type: Object,
      default: () => {
        return {
          width: '180px',
          height: '180px'
        }
      }
    },
    limit: Number,
    accept: {
      type: String,
      default: () => {
        return config.upload.image.accept
      }
    },
    clearFile: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    listtype: {
      type: String,
      default: () => {
        return 'picture'
      }
    },
    filelist: {
      type: Array,
      default: () => {
        return []
      }
    },
    autoupload: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    drag: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    multiple: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    showfilelist: {
      tyle: Boolean,
      default: () => {
        return true
      }
    },
    disabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  mounted() {
    this.$dragging.$on('dragend', (value) => {
      this.$emit('on-dragend', this.list)
    })
  },
  computed: {
    getTextPrompt() {
      if (this.hideTextPrompt) return ''
      if (this.textPrompt) return this.textPrompt
      else {
        if (this.accept.indexOf('video') >= 0) {
          return config.upload.video.tips
        } else {
          return config.upload.image.tips
        }
      }
    }
  },
  data() {
    return {
      fileType: 'image',
      visible: false,
      randomDraggingGroup: Math.random() * 1000 + 'uploaddrag',
      loading: false,
      uploadHeaders: {
        Authorization: `Bearer ${store.state.auth.token}`
      }
    }
  },
  watch: {
    accept: {
      immediate: true,
      handler(newVal) {
        if (newVal.indexOf('image') > -1) {
          this.fileType = 'image'
        } else {
          this.fileType = 'video'
        }
      }
    }
  },
  methods: {
    async updateSuccess(res, index) {
      this.loading = false
      const newList = [...this.list]
      let url = config.api.imageURL + res.data.url
      newList[index].url = url
      this.$emit('on-success', newList)
    },
    updateUpdateSuccess(res, index, img) {
      this.$set(img, 'loading', false)
      const newList = [...this.list]
      let url = config.api.imageURL + res.data.url
      newList[index].url = url
      this.$emit('on-success', newList)
    },
    //上传文件完成
    async uploadSuccess(res) {
      this.loading = false
      let url = config.api.imageURL + res.data.url
      const newlist = [...this.list]
      newlist.push({ url })
      this.$emit('on-success', newlist)
    },
    checkedImg(ary) {
      this.$emit('on-success', [...this.list, ...ary])
      this.visible = false
    },
    // 上传文件错误
    async uploadError(err) {
      this.loading = false
      try {
        const errmsg = JSON.parse(err.message)
        this.$message.error(errmsg.message ? errmsg.message : '上传文件失败')
      } catch (err) {
        this.$message.error('上传文件失败')
      }
    },
    // 上传文件错误
    async uploadUpdateError(err, img) {
      this.$set(img, 'loading', false)
      try {
        const errmsg = JSON.parse(err.message)
        this.$message.error(errmsg.message ? errmsg.message : '上传文件失败')
      } catch (err) {
        this.$message.error('上传文件失败')
      }
    },
    // 开始上传文件
    beforeUpload(file) {
      // 验证视频图片的大小
      const err = this.$upload.verify(file)
      if (err) {
        this.$message.error(err)
        return false
      }
      this.loading = true
      this.$emit('before-upload', file)
    },
    beforeUpdateUpload(file, img) {
      // 验证视频图片的大小
      const err = this.$upload.verify(file)
      if (err) {
        this.$message.error(err)
        return false
      }
      this.$set(img, 'loading', true)
      this.$emit('before-upload', file)
    },
    // 上传文件超出限制
    uploadExceed() {
      this.$emit('exceed')
    },
    //删除图片
    deleteImg(index) {
      const newList = [...this.list]
      newList.splice(index, 1)
      this.$emit('on-remove', newList)
    }
  }
}
</script>
